/**
 * Design-wise
 * Scrolly JS
 */

/**
 * @section Includes
 */

import throttle from 'lodash/throttle';

/**
 * @section Legacy Module
 */

const dw = {};
dw.termY = [];
dw.termID = [];

dw.clickHandler = function (e) {
  var termID = e.target.href.split('#')[1];
  dw.goTo(termID);
  e.preventDefault();
};

dw.init = function () {
  // 1. Set up initial values
  dw.termWindow = document.querySelector('#term_window');
  dw.totalHeight = dw.termWindow.scrollHeight;

  // 2. Scroll to linked term, if any
  var terms = document.querySelectorAll('.dw-term');
  if (window.location.hash.length) {
    dw.currentTerm = parseInt(window.location.hash.split('#')[1]);
  } else {
    dw.currentTerm = parseInt(terms[0].dataset.id);
  }

  // 3. Calculate heights
  terms.forEach(function (el, i) {
    var y = dw.termWindow.scrollTop + el.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top;
    dw.termID.push(parseInt(el.dataset.id));
    dw.termY.push(y);
  });
  dw.goTo(dw.currentTerm);

  // 4. Handle link clicks
  var links = document.querySelectorAll('.dw-nav a');
  links.forEach(function (el, i) {
    el.addEventListener('click', dw.clickHandler);
  });

  // 5. Recalculate heights while loading & resizing
  dw.loading();
  window.addEventListener('resize', dw.measure);
  dw.termWindow.addEventListener('scroll', dw.scrollHandler);

  // 6. Set up mobile nav
  window.addEventListener('scroll', dw.mobileScrollHandler);
};

dw.highlight = throttle(function () {
  // 1. Get current category
  var term = dw.currentTerm + "";
  var cat = term.substr(0, term.length - 2);
  if(cat === null || undefined) {
    return false;
  }

  // 2. Show current category pane
  var tabs = document.querySelectorAll('.dw-nav--term');
  tabs.forEach(function (el, i) {
    el.classList.add('is-hiding');
  });
  document.querySelector(`#cat_${cat}`).classList.remove('is-hiding');

  // 3. Highlight current term & category
  var links = document.querySelectorAll('.dw-nav a');
  links.forEach((el, i) => {
    el.classList.remove('is-viewing');
  });
  history.replaceState(undefined, undefined, `#${dw.currentTerm}`);
  document.querySelector(`.dw-nav--term a[data-id="${term}"]`).classList.add('is-viewing');
  document.querySelector(`.dw-nav a[data-cat="${cat}00"]`).classList.add('is-viewing');
}, 16);

dw.loading = () => {
  var instaClass = '.instagram-media';
  var instaRenderedClass = '.instagram-media-rendered';
  var loadClear = setInterval(() => {
    var insta = document.querySelectorAll(instaClass);
    var instaRendered = document.querySelectorAll(instaRenderedClass);

    // This '+ 1' seems wonky, but for some reason, when scrolled to
    // a term on page load, it adds that term twice to the insta list
    // but doesn't add it to the rendered list
    if ((insta.length > instaRendered.length + 1)) {
      dw.measure();
    } else {
      clearInterval(loadClear);
      dw.isLoaded = true;
      setTimeout(dw.measure, 500);
    }
  }, 16);
};

dw.goTo = function (term) {
  dw.isNavigating = true;
  var magicAdjustment = 2;
  var termEl = document.querySelector('.dw-term[data-id="' + term + '"]');
  // If valid term
  if (termEl) {
    dw.termWindow.scrollTop = dw.termWindow.scrollTop + termEl.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top + magicAdjustment;
    dw.currentTerm = parseInt(term);
    dw.highlight();

  // If valid category
  } else {
    var cat = document.querySelector('.dw-heading[data-cat="' + term + '"]');
    if (cat) {
      dw.termWindow.scrollTop = dw.termWindow.scrollTop + cat.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top + magicAdjustment;
      dw.currentTerm = parseInt(cat.nextElementSibling.dataset.id);
      dw.highlight();
    }
  }
  dw.isNavigating = false;
};

dw.measure = function () {
  if (dw.termWindow.scrollHeight !== dw.totalHeight) {
    var terms = document.querySelectorAll('.dw-term');
    var diff = [];
    // Get new tops of each
    terms.forEach(function (term, i) {
      var y = Math.floor(dw.termWindow.scrollTop + term.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top);
      if (dw.termY[i] !== y) {
        dw.termY[i] = y;
        diff.push(parseInt(term.dataset.id));
      }
    });

    // See if user has scrolled past loaded area
    if (dw.currentTerm >= diff.reduce((a, b) => a < b ? a : b)) {
      dw.goTo(dw.currentTerm);
    }
    dw.totalHeight = dw.termWindow.scrollHeight;
  }
};

dw.mobileScrollHandler = throttle(function () {
  var mobileNav = document.querySelector('.dw-mobile');
  if (mobileNav.getBoundingClientRect().top <= 0) {
    mobileNav.classList.add('is-fixed');
  } else {
    mobileNav.classList.remove('is-fixed');
  }
}, 33);

dw.scrollHandler = throttle(() => {
  if (dw.isLoaded) {
    var magicAdjustment = 64;
    var n = 0;
    while (dw.termWindow.scrollTop + magicAdjustment > dw.termY[n]) {
      n++;
    }
    dw.currentTerm = dw.termID[n-1];
    dw.highlight();
  }
}, 100);

export default dw;



// WEBPACK FOOTER //
// ./components/_designwise.js